var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "yxt-drawer",
        {
          attrs: {
            "destroy-on-close": true,
            size: "960px",
            title: _vm.$t("pc_ac_lbl_outer_management").d("游客管理"),
            visible: _vm.showExernalDrawer,
            "before-close": function (done) {
              return done(false)
            },
          },
          on: {
            "update:visible": function ($event) {
              _vm.showExernalDrawer = $event
            },
            closed: _vm.closeDrawer,
          },
        },
        [
          _c("external-select", {
            ref: "externalSelect",
            attrs: { "activity-id": _vm.activityId, selected: _vm.selected },
          }),
          _vm.inStage
            ? _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c("yxt-button", { on: { click: _vm.closeDrawer } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("pc_ac_btn_cancel").d("取消")) +
                        "\n      "
                    ),
                  ]),
                  _c(
                    "yxt-button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("pc_ac_btn_sure").d("确定")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }